export const ROUTES = {
  HOME: '',
  IDENTCODES: 'identification-code',
  ERROR: {
    ERROR: 'error',
    NOT_FOUND: 'not-found',
    NOT_AUTHORIZED: 'not-authorized',
    SERVER_ERROR: 'server-error',
    SESSION_EXPIRED: 'session-expired'
  },
  REDIRECT_URI: 'oauth/callback',
  LOGIN: 'login',
  SILENT_REFRESH: 'silent-refresh'
};
